'use strict';

require('core-js/es6/symbol');

require('core-js/fn/array/iterator');

require('airbnb-js-shims');